import React from 'react';
import '../css/Navbar.css';
import { NavLink, useNavigate } from 'react-router-dom';


const NavbarButton = ({ label, icon: Icon, onClick, to, style, className }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (to) {
      navigate(to);
    } else if (onClick) {
      onClick();
    }
  };

  return to ? (
    <NavLink
      to={to}
      className={({ isActive }) => `custom-button ${className} ${isActive ? 'active' : ''}`}
      style={style}
    >
      {Icon && <Icon className="button-icon" />}
      {label}
    </NavLink>
  ) : (
    <button
      className={`custom-button ${className}`}
      onClick={handleClick}
      style={style}
    >
      {Icon && <Icon className="button-icon" />}
      {label}
    </button>
  );
};


export default NavbarButton;